module.exports = __webpack_public_path__ + "static/agile-c1bc84cbcef738aefe631ce08317ebd8.svg";